import { IPrices } from '../../apps/comparator/models';
import IconContainer from '../IconContainer';
import { IconWrapper, PricesContainer, PriceStyled } from './styles';
import { ReactComponent as PriceUnique } from '../../assets/svg/PrecioUnico.svg';

export interface PricesProps {
  prices?: IPrices[];
  isFirst?: boolean;
  iconsDisplayed?: boolean;
}

const defaultProps: PricesProps = {
  prices: [],
  isFirst: true,
  iconsDisplayed: true,
};

export interface IconPriceProps {
  visible?: boolean;
}

const Prices = ({ prices = [], iconsDisplayed, ...other }: PricesProps) => {
  return (
    <PricesContainer visible={iconsDisplayed}>
      {prices.map(({ type, label, symbol, price, unit }, index) => (
        <>
          {index === 0 && (
            <IconWrapper visible={iconsDisplayed}>
              {type === 'CMR' && <IconContainer Icon={PriceUnique} style={{ maxWidth: 80, height: 20 }} disabled />}
            </IconWrapper>
          )}
          <div>
            <PriceStyled isFirst={index === 0} {...other}>
              {label && index > 0 && label + ' '}
              {symbol}
              {price} {unit}
            </PriceStyled>
          </div>
        </>
      ))}
    </PricesContainer>
  );
};

Prices.defaultProps = defaultProps;

export default Prices;
